<template>
  <div>
    <div class="container-fluid title-page">
      <v-row>
        <v-col cols="12" sm="12">
          <h2>Meu cadastro</h2>
        </v-col>
      </v-row>
    </div>

    <v-form ref="form" v-model="valid" lazy-validation>
      <div class="container-fluid">
        <v-card class="mt-10 mb-10" style="padding: 24px;">
          <v-row>
            <v-hover
              v-slot:default="{ hover }"
            >
              <v-col cols="12" md="12" class="user-thumb-edit">
                <v-img :src="thumb" width="170" height="170"></v-img>
                <v-overlay
                  absolute
                  :value="hover"
                  width="170"
                  height="170"
                >
                  <upload-btn block title="Alterar foto"
                              color="primary"
                              @file-update="fileImageChange"
                              accept="image/*"
                              :disabled="sending"
                              :uniqueId="true">
                  </upload-btn>
                </v-overlay>
              </v-col>
            </v-hover>

            <v-col cols="12" sm="12" md="12" lg="4" class="col-mg">
              <v-text-field
                v-model="user.email"
                :rules="[rules.required, rules.email]"
                label="Email"
                outlined
                required
                :disabled="sending"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="4" class="col-mg">
              <v-text-field
                v-model="password"
                key="password"
                :append-icon="show1 ? 'fa-eye' : 'fa-eye-slash'"
                :type="show1 ? 'text' : 'password'"
                :rules="[rules.min]"
                label="Senha"
                hint="Preencha caso deseje alterar"
                counter
                outlined
                @click:append="show1 = !show1"
                :disabled="sending"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="4" class="col-mg">
              <v-text-field
                key="password_conf"
                :append-icon="show2 ? 'fa-eye' : 'fa-eye-slash'"
                :type="show2 ? 'text' : 'password'"
                :rules="[rules.passwordMatch]"
                name="input-10-2"
                label="Confirme sua senha"
                @click:append="show2 = !show2"
                :disabled="sending"
                outlined
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12">
              <v-radio-group v-model="user.type" row class="user-type">
                <v-radio label="Pessoa Física" value="pf" :disabled="sending"></v-radio>
                <v-radio label="Pessoa Jurídica" value="pj" :disabled="sending"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row v-if="user.type === 'pf'">
            <v-col cols="12" md="4">
              <v-text-field
                key="user.name"
                v-model="user.name"
                :rules="[rules.requiredPF]"
                label="Nome"
                required
                :disabled="sending"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                key="user.cpf"
                v-model="user.cpf"
                :rules="[rules.requiredPF, rules.cpf]"
                label="CPF"
                v-mask="'###.###.###-##'"
                required
                :disabled="sending"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                key="user.phone"
                v-model="user.phone"
                :rules="[rules.requiredPF]"
                label="Telefone"
                v-mask="['(##) ####-####', '(##) #####-####']"
                required
                :disabled="sending"
                outlined
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="user.type === 'pj'">
            <v-col cols="12" md="12" style="margin: -20px 0;">
              <v-switch v-model="user.isMei" inset :label="(user.isMei ? 'Sou MEI' : 'Não sou MEI')"></v-switch>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="4" class="col-mg-mobile">
              <v-text-field
                key="user.cnpj"
                v-model="user.cnpj"
                :rules="[rules.requiredPJ, rules.cnpj]"
                label="CNPJ"
                required
                v-mask="'##.###.###/####-##'"
                :disabled="sending"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="4" class="col-mg-mobile">
              <v-text-field
                key="user.corporateName"
                v-model="user.corporateName"
                :rules="[rules.requiredPJ]"
                label="Razão Social"
                required
                :disabled="sending"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="4" class="col-mg-mobile">
              <v-text-field
                key="user.fantasyName"
                v-model="user.fantasyName"
                :rules="[rules.requiredPJ]"
                label="Nome Fantasia"
                required
                :disabled="sending"
                outlined
              ></v-text-field>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row>
            <v-col cols="12" md="3">
              <v-text-field
                key="user.cep"
                v-model="user.cep"
                label="CEP"
                v-mask="'#####-###'"
                :disabled="sending || loadingAddress"
                :hint="(loadingAddress ? 'Buscando endereço...' : null)"
                persistent-hint
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                key="user.address"
                v-model="user.street"
                label="Endereço"
                :disabled="sending || loadingAddress"
                :loading="loadingAddress"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                key="user.number"
                v-model="user.number"
                label="Número"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                key="user.complement"
                v-model="user.complement"
                label="Complemento"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                key="user.neighborhood"
                v-model="user.neighborhood"
                label="Bairro"
                :disabled="sending || loadingAddress"
                :loading="loadingAddress"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                key="user.city"
                v-model="user.city"
                label="Cidade"
                :disabled="sending || loadingAddress"
                :loading="loadingAddress"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                key="user.state"
                v-model="user.state"
                :items="states"
                item-value="uf"
                item-text="name"
                label="Estado"
                :disabled="sending || loadingAddress"
                :loading="loadingAddress"
                outlined
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="text-right">
              <v-btn class="primary" @click="saveData" :loading="sending || loadingAddress"
                     :disabled="sending || loadingAddress">Salvar
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </div>
    </v-form>

    <v-snackbar
      v-model="alert.show"
      :color="alert.color"
    >
      <v-row no-gutters>
        <v-col cols="10" class="text-left">
          {{ alert.text }}
        </v-col>
        <v-col cols="2" class="text-right">
          <v-btn
            text
            icon
            x-small
            @click="alert.show = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-snackbar>
  </div>
</template>

<script>
import UploadButton from 'vuetify-upload-button'
import cep from 'cep-promise'
import { mask } from 'vue-the-mask'
import { encrypt, isValidCNPJ, isValidCPF, states } from '@/helpers'
import { mapActions } from 'vuex'

export default {
  name: 'UserRegister',
  components: {
    'upload-btn': UploadButton
  },
  directives: { mask },
  data: vm => ({
    alert: {
      show: false,
      text: null,
      color: null
    },
    loading: false,
    sending: false,
    loadingAddress: false,
    valid: false,
    thumb: '/img/user-bg-default.629fa546.jpg',
    user: {
      name: '',
      email: '',
      type: 'pf',
      cpf: '',
      cnpj: '',
      phone: '',
      corporateName: '',
      fantasyName: '',
      isMei: false,
      cep: '',
      street: '',
      number: '',
      neighborhood: '',
      complement: '',
      city: '',
      state: '',
    },
    states,
    fileImage: null,
    password: '',
    show1: false,
    show2: false,
    absolute: true,
    overlay: false,
    rules: {
      required: (value) => !!value || 'Obrigatório',
      requiredPF: (value) => {
        if (vm.user.type === 'pf' && !value) {
          return 'Obrigatório'
        }

        return true
      },
      requiredPJ: (value) => {
        if (vm.user.type === 'pj' && !value) {
          return 'Obrigatório'
        }

        return true
      },
      cpf: (value) => {
        if (vm.user.type === 'pf' && !isValidCPF(value)) {
          return 'CPF Inválido'
        }

        return true
      },
      cnpj: (value) => {
        if (vm.user.type === 'pj' && !isValidCNPJ(value)) {
          return 'CNPJ Inválido'
        }

        return true
      },
      min: v => (v.length >= 8 || !v) || 'Minímo 8 caracteres',
      passwordMatch: (v) => (v === vm.password || (!v && !vm.password)) || ('Confirmação incorreta'),
      email: (v) => /.+@.+/.test(v) || 'E-mail inválido',
    },
  }),
  created () {
    this.getUserData()
  },
  watch: {
    'user.cep' (val) {
      if (val && val.length >= 9) {
        this.loadingAddress = true

        this.user.street = ''
        this.user.neighborhood = ''
        this.user.city = ''
        this.user.state = ''
        this.user.number = ''
        this.user.complement = ''

        cep(val).then(result => {
          if (result) {
            this.user.street = result.street
            this.user.neighborhood = result.neighborhood
            this.user.city = result.city
            this.user.state = result.state
          }
        }).catch(err => {
          console.error(err)

          this.alert.text = err.message
          this.alert.color = 'error'
          this.alert.show = true
        }).finally(() => {
          this.loadingAddress = false
        })
      }
    }
  },
  methods: {
    ...mapActions(['setUser']),
    fileImageChange (file) {
      this.fileImage = file
      const reader = new FileReader()
      reader.onload = (e) => {
        this.thumb = e.target.result
      }
      reader.readAsDataURL(file)
    },
    saveData () {
      if (this.$refs.form.validate()) {
        this.sending = true

        const formData = new FormData(),
          dataStore = {}

        formData.append('email', this.user.email)
        formData.append('type', this.user.type)

        if (this.user.cep) {
          formData.append('cep', this.user.cep.replace(/\D/g, ''))
        }
        if (this.user.street) {
          formData.append('street', this.user.street)
        }
        if (this.user.number) {
          formData.append('number', this.user.number)
        }
        if (this.user.complement) {
          formData.append('complement', this.user.complement)
        }
        if (this.user.neighborhood) {
          formData.append('neighborhood', this.user.neighborhood)
        }
        if (this.user.city) {
          formData.append('city', this.user.city)
        }
        if (this.user.state) {
          formData.append('state', this.user.state)
        }

        if (this.password) {
          const encryptObj = encrypt(this.password)

          formData.append('password', encryptObj.ciphertext)
          formData.append('buffer', JSON.stringify(encryptObj.nonce.toJSON()))
        }

        if (this.user.type === 'pf') {
          formData.append('name', this.user.name)
          formData.append('cpf', this.user.cpf.replace(/\D/g, ''))
          formData.append('phone', this.user.phone.replace(/\D/g, ''))

          dataStore.name = this.user.name
        }

        if (this.user.type === 'pj') {
          formData.append('corporateName', this.user.corporateName)
          formData.append('fantasyName', this.user.fantasyName)
          formData.append('cnpj', this.user.cnpj.replace(/\D/g, ''))
          formData.append('isMei', this.user.isMei)

          dataStore.name = this.user.fantasyName
        }

        if (this.fileImage) {
          formData.append('image', this.fileImage)

          dataStore.thumb = this.thumb
        }

        this.axios.post('/user/update', formData).then(({ data }) => {
          if (data.success) {
            this.alert.text = 'Dados salvos'
            this.alert.color = 'success'

            this.fileImage = null

            this.setUser(dataStore)
          } else {
            this.alert.text = data.message
            this.alert.color = 'error'
          }
        }).catch(err => {
          console.error(err)

          this.alert.text = 'Erro ao salvar os dados'
          this.alert.color = 'error'
        }).finally(() => {
          this.sending = false
          this.alert.show = true
        })
      }
    },
    getUserData () {
      this.loading = true

      this.axios.get('/user/iam').then(({ data }) => {
        if (data.success) {
          this.user = data.user

          if (data.user.thumb) {
            this.thumb = data.user.thumb
          }
        } else {
          this.alert.text = data.message
          this.alert.color = 'error'
          this.alert.show = true
        }
      }).catch(err => {
        console.error(err)

        this.alert.text = 'Erro ao trazer os dados'
        this.alert.color = 'error'
        this.alert.show = true
      }).finally(() => {
        this.loading = false
      })
    }
  }

}
</script>

<style scoped>
.col-mg {
  margin-top: 20px;
}

@media (max-width: 991px) {
  .col-mg, .col-mg-mobile {
    margin-top: 0;
    margin-bottom: -15px;
  }
}
</style>
